import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {QuotationService} from "../../services/quotation-service/quotation.service";
import {ValidationService} from "../../services/validation-service/validation.service";
import {ErrorMessages} from "../../model/ErrorMessages";
import {WebLeadType} from "../../model/leads/WebLeadType";
import {ErrorCodes} from "../../model/ErrorCodes";
import {LeadService} from "../../services/lead-service/lead.service";
import {ContentComponent} from "../content/content.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {InsureFragment} from "../../model/InsureFragment";
import {DiscoveryGa4AngularService} from "discovery-ga4-angular";

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit {
  @Input() isCallBackForm: boolean;
  @Output() submitButtonClicked = new EventEmitter<boolean>();
  @Output() showActiveProductFragment = new EventEmitter<boolean>();
  callBackButtonClicked = true;
  errorMessage = ErrorMessages;
  contentID = '';
  captureForm: FormGroup;
  showFragment = false;
  fragment: string;
  submitted = false;
  private showServiceError = false;
  facebookReference = false;
  facebookClickID: string;
  fbpCookieValue: string;
  urlHasLeadReference = false;
  leadReferenceNumber: string;
  referenceNumber: number;
  showSpinner = false;

  constructor(public quotationService: QuotationService,
              public validationService: ValidationService,
              public contentComponent: ContentComponent,
              private _leadService: LeadService,
              private _formBuilder: FormBuilder,
              private _discoveryGA4AngularService: DiscoveryGa4AngularService) {
  }

  ngOnInit(): void {
    this.validationService.retrievedLoggedInUser();
    this.contentComponent.customGetContent('/discoverycoza/fragments/car-and-home-insurance/quotes/step1-id-number-tool-tip')
      .subscribe((result) => {
        this.contentID = result;
      });

    this.urlHasLeadReference = localStorage.getItem('urlHasLeadReference') == 'true';
    this.referenceNumber = +localStorage.getItem('leadReferenceNumbers');
    if (this.urlHasLeadReference) {
      this._leadService.cacheLeadReference(this.referenceNumber.toString()).subscribe();
    }

    this.facebookReference = localStorage.getItem('urlHasFacebookReference') === 'true';

    if (this.facebookReference){

      this.facebookClickID = localStorage.getItem('facebookReferenceNumber');
      this.fbpCookieValue = localStorage.getItem('fbpCookieValue');
      this.quotationService.quotationRequest.fbClickID = this.facebookClickID;
      this.quotationService.quotationRequest.fbBrowserID = this.fbpCookieValue;
    }
    else{
      this.quotationService.quotationRequest.fbClickID = '';
      this.quotationService.quotationRequest.fbBrowserID = '';
    }

  }

  get f() {
    return this.captureForm.controls;
  }

  isUserLoggedIn() {
    return this.validationService.loggedIn;
  }

  submitForms(){
    this.submitted = true;
    this.showSpinner = true;
    setTimeout(() => {
      if(this._leadService.createLeadResponse && this._leadService.createLeadResponse.leadReferenceNumber){
        this._callDiscoveryGA4Service('generate_lead', 'insure_call_me_back_form', 'call_me_back',
          1, +this._leadService.createLeadResponse.leadReferenceNumber);
      }
      if(this.urlHasLeadReference){
        this._callDiscoveryGA4Service('generate_lead', 'insure_call_me_back_form', 'call_me_back',
          1, this.referenceNumber);
      }
    }, 1000)

    this.validationService.clearErrors();
    if (this.validationService.isLeadFormValid()) {
      this.callBackButtonClicked = true;
      if(this._leadService.doesUserHaveProduct){
        this.showActiveProductFragment.emit(true);
      }else if (this._leadService.createLeadResponse.leadReferenceNumber) {
        this._updateLead();
      }
    } else {
      this.callBackButtonClicked = false;
    }
  }

  logNinjaLead() {
    this.quotationService.quotationRequest.urlParams = localStorage.getItem('lead_url_params') != null ? encodeURIComponent(localStorage.getItem('lead_url_params')) : null;
    this._trimValues();
    this.validationService.errorMessages = [];
    if (this.quotationService.quotationRequest.cellphone !== '' &&
      this.quotationService.quotationRequest.cellphone !== null &&
      this.quotationService.quotationRequest.idNumber !== '' &&
      this.quotationService.quotationRequest.idNumber !== null &&
      this.validationService.checkID(this.quotationService.quotationRequest.idNumber) &&
      this.validationService.isCellPhoneValid() && this.validationService.isNameValid()) {
        if (this.urlHasLeadReference) {
          this._updateMobileNinjaLead();
        } else {
          if (this.isCallBackForm) {
            this.quotationService.quotationRequest.medium = 'Call me back';
          } else {
            this.quotationService.quotationRequest.medium = '60 second quote';
          }
          this.quotationService.quotationRequest.medium = this.facebookReference? this.quotationService.quotationRequest.medium.concat(' - FACEBOOK') : this.quotationService.quotationRequest.medium;

          this._leadService.registerLead(WebLeadType.WEB_LEAD_4).subscribe(response => {
            this.showSpinner = false;
            this._leadService.createLeadResponse = response.body;
            if (!this.isCallBackForm && this._leadService.createLeadResponse.leadReferenceNumber) {
              this._callDiscoveryGA4Service('generate_lead_ninja', 'insure_quote_tool', '',
                null, response.body['leadReferenceNumber']);
            } else if (this.isCallBackForm && this._leadService.createLeadResponse.leadReferenceNumber) {
              this._callDiscoveryGA4Service('generate_lead_ninja', 'insure_call_me_back_form', 'call_me_back',
                1, response.body['leadReferenceNumber']);
            }
            if (this.submitted) {
              this._updateLead();
            }
          }, error => {
            this.showSpinner = false;
            if (error.status === ErrorCodes.USER_HAS_PRODUCT) {
              this._leadService.doesUserHaveProduct = true;
              if (this.submitted) {
                this.showActiveProductFragment.emit(true);
              }
            } else {
              this.showServiceError = true;
            }
          });
          sessionStorage.setItem('insureLeadRegistered', 'true');
        }
    }
  }

  private _trimValues() {
    if (this.quotationService.quotationRequest.name) {
      this.quotationService.quotationRequest.name = this.quotationService.quotationRequest.name.trim();
    }
    if (this.quotationService.quotationRequest.surname) {
      this.quotationService.quotationRequest.surname = this.quotationService.quotationRequest.surname.trim();
    }
    if (this.quotationService.quotationRequest.cellphone) {
      this.quotationService.quotationRequest.cellphone = this.quotationService.quotationRequest.cellphone.trim();
    }
  }

  private _updateLead() {
    this.quotationService.quotationRequest.vehicleUsage = null;
    this.quotationService.quotationRequest.parkingSecurity = null;
    if(this.urlHasLeadReference && this.callBackButtonClicked){
      this.quotationService.quotationRequest.medium = 'MOBILE';
    }
      this._leadService.updateLead(WebLeadType.WEB_LEAD_1, null, null, null,
        this.quotationService.campaign, this.quotationService.quotationRequest.medium, 'WEBSITE').subscribe(
        (response) => {
          if (response) {
            this._getFragment();
          }
        }, error => {
          this.showServiceError = true;
        });
  }

  private _getFragment() {
    this._leadService.getCrossSellProductFragment().subscribe((response: InsureFragment) => {
      if (response) {
        this.fragment = response.fragment;
        this._leadService.fragment = this.fragment;
        this.showFragment = true;
        this.submitButtonClicked.emit(this.showFragment);
      }
      }, error => {
      console.warn(error);
      this.showServiceError = true;
    });
  }

  private _updateMobileNinjaLead (){
    if (this.isCallBackForm) {
      this.quotationService.quotationRequest.medium = 'Call me back';
    }
    this.quotationService.quotationRequest.vehicleUsage = null;
    this.quotationService.quotationRequest.parkingSecurity = null;

    this._leadService.updateLead(WebLeadType.WEB_LEAD_4, null, null, null,
      this.quotationService.quotationRequest.campaign, 'MOBILE', 'WEBSITE').subscribe(
      (response) => {
        if (response.status === ErrorCodes['USER_HAS_PRODUCT']) {
          this._leadService.doesUserHaveProduct = true;
          if (this.submitted) {
            this.showActiveProductFragment.emit(true);
          }
        } else {
          this._leadService.doesUserHaveProduct = false;
        }

        if (this.isCallBackForm && this.referenceNumber) {
          this._callDiscoveryGA4Service('generate_lead_ninja', 'insure_call_me_back_form', 'call_me_back',
            1, this.referenceNumber);
        } else if (!this.isCallBackForm && this.referenceNumber) {
          this._callDiscoveryGA4Service('generate_lead_ninja', 'insure_quote_tool', '',
            null, this.referenceNumber);        }
      }, error => {
        this.showServiceError = true;
      });
  }

  private _callDiscoveryGA4Service(event: string, formName: string, formAction: string, formStep: number, leadID: number) {
      let postMessage = {
        'event': event,
        'event_parameters': {
          'form_name': formName,
          'form_action': formAction,
          'form_step': formStep,
          'lead_id': leadID
        },
        'sentFrom': 'angular-iframe'
    }
    if (!formStep) {
      delete postMessage.event_parameters.form_step;
    }
    if (!formAction) {
      delete postMessage.event_parameters.form_action;
    }
    if (event === 'generate_lead') {
      postMessage['user'] = {
        'first_name': this.quotationService.quotationRequest.name,
        'last_name': this.quotationService.quotationRequest.surname,
        'email': this.quotationService.quotationRequest.email,
        'phone': this.quotationService.quotationRequest.cellphone.replace(this.quotationService.quotationRequest.cellphone.charAt(0), '+27')
      }
    }
    this._discoveryGA4AngularService.postMessage(postMessage);
  }


}
